import { InjectionToken } from '@angular/core';

import { IFormFieldDefaultOptions } from '../form-field-default-options';

export const FILTER_CONTROL_OPTIONS_TOKEN = new InjectionToken<IFormFieldDefaultOptions>('FILTER_CONTROL_OPTIONS_TOKEN');
